export const plByMonth = [
  { name: 'Jan', pl: 1000, avg: 500, inc: 300 },
  { name: 'Feb', pl: 2000, avg: 900, inc: 400 },
  { name: 'Apr', pl: 400, avg: 400, inc: 500 },
  { name: 'Mar', pl: 3100, avg: 1300, inc: 700 },
  { name: 'May', pl: 200, avg: 100, inc: 200 },
  { name: 'Jun', pl: 600, avg: 400, inc: 300 },
  { name: 'Jul', pl: 500, avg: 90, inc: 100 }
]

export const plMonthYear = [
  { name: 'Jan/21', pl: 80, avg: 100, inc: 300 },
  { name: 'Feb/21', pl: -15, avg: 100, inc: 400 },
  { name: 'Apr/21', pl: 170, avg: 100, inc: 500 },
  { name: 'Mar/21', pl: -400, avg: 100, inc: 700 }
]

export const trades = [
  { nbOfTrades: 3, pl: 200 },
  { nbOfTrades: 10, pl: 100 },
  { nbOfTrades: 5, pl: 400 },
  { nbOfTrades: 25, pl: 20 },
  { nbOfTrades: 15, pl: 120 },
  { nbOfTrades: 8, pl: 110 }
]
